import { OrderListItem } from "../../model/OrderListSuccessResponse";
import { GetOrderListFilters } from "../../model/GetOrderListFilters";
import { OrderByFilter } from "../../model/GetOrderListOrderBy";
import { OrganizationKeyName } from "../../../../model/Organization";
import { Order } from "../../model/OrderSuccessResponse";
import { httpClient } from "../../../../service/http";
import { PostPayload } from "../../../../model/http-crud-models";

export const orderHttp = {
  getOrders: async (
    organizationKeyName: OrganizationKeyName,
    filters: GetOrderListFilters,
    orderBy: OrderByFilter,
    limit?: number
  ) => {
    const searchParams = new URLSearchParams();
    const { filterByStates, filterByShop, ...rest } = filters;
    if (filterByShop) {
      searchParams.append("filterByShops[]", filterByShop);
    }
    if (filterByStates) {
      filterByStates.forEach((state) => {
        searchParams.append("filterByStates[]", state);
      });
    }
    if (limit) {
      searchParams.append("limit", limit.toString());
    }

    if (rest) {
      Object.entries(rest).forEach(([key, value]) => {
        searchParams.set(key, decodeURIComponent(value));
      });
    }
    if (orderBy) {
      searchParams.set("orderBy", orderBy.orderBy);
      searchParams.set("sortDir", orderBy.sortDir);
    }
    const res = await httpClient<{ data: OrderListItem[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/order?${searchParams.toString()}`,
    });
    return res.data;
  },

  getOrder: async (organizationKeyName: OrganizationKeyName, id?: string) => {
    const res = await httpClient<{ data: Order }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/order/${id}`,
    });
    return res.data;
  },

  refundOrder: async ({
    organizationKeyName,
    data: { amount, orderId },
  }: PostPayload<{ amount: number; orderId: string }>) => {
    return httpClient<{}>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/order/${orderId}/refund`,
      data: { amount },
    });
  },

  // Only full refund supported for now
  refundGiftCard: async ({
    organizationKeyName,
    orderId,
  }: {
    organizationKeyName: OrganizationKeyName;
    orderId: string;
  }) => {
    return httpClient<{}>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/order/${orderId}/refund-gift-card`,
      data: {},
    });
  },

  rejectOrder: async ({
    organizationKeyName,
    data: { reason, orderId },
  }: PostPayload<{ reason: string; orderId: string }>) => {
    return httpClient<{}>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/order/${orderId}/reject`,
      data: { reason },
    });
  },
};
